import { SectionsEnum } from 'enums/sections.enum';

export const RoutesDictionary: Record<SectionsEnum, string> = {
    [SectionsEnum.FORGOT_PASSWORD]: 'forgot-password',
    [SectionsEnum.LOGIN]: 'login',
    [SectionsEnum.LOGOUT]: 'logout',
    [SectionsEnum.NO_ACCOUNT]: 'no-account',
    [SectionsEnum.SELECT_APP]: 'select-app',
};
